/**
 * @author: Real Links <engineering@reallinks.io> (https://real-links.github.io)
 * @license: © 2018 Real Links Limited
 * @link: https://real-links.github.io
 */
const _isPlainObject = require('lodash/isPlainObject');

function assert(value, err) {
  if (!value) {
    throw err;
  }
}

function packSingleJSON(input) {
  assert(_isPlainObject(input), new Error('Expected argument to be a plain object'));
  return Object.keys(input).reduce((output, key) => {
    if (_isPlainObject(input[key]) || Array.isArray(input[key])) {
      output[key] = JSON.stringify(input[key]);
    } else {
      output[key] = input[key];
    }
    return output;
  }, {});
}

function unpackSingleJSON(input) {
  assert(_isPlainObject(input), new Error('Expected argument to be a plain object'));
  return Object.keys(input).reduce((output, key) => {
    const { [key]: value } = input;
    if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
      output[key] = JSON.parse(value);
    } else {
      output[key] = value;
    }
    return output;
  }, {});
}

module.exports = {
  packSingleJSON,
  unpackSingleJSON,
  pack: packSingleJSON,
  unpack: unpackSingleJSON,
};



// WEBPACK FOOTER //
// ./src/lib/pack-single-json.js